<template>
    <div class="modal fade in" data-backdrop="static" data-keyboard="false" id="ModalRecusa">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title"><i class="fa fa-times-circle-o"></i> Recusar documento:
                        <b>{{file.arquivo_nome}}</b>
                    </p>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label :class="{ 'text-danger': errors.has('Motivo') }">
                                    <required /> Motivo</label>
                                <textarea name="Motivo" v-model="request.motivo"
                                    :class="{ 'is-invalid': errors.has('Motivo') }"
                                    v-validate="{required:true, min: 15}" rows="4"
                                    placeholder="Digite o motivo para recusar o arquivo" class="form-control">
                                </textarea>
                                <div class="invalid-feedback help-block error">{{errors.first('Motivo')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" data-dismiss="modal" class="btn btn-default float-left"><i
                            class="fa fa-times"></i>
                        {{ $t('words.cancel')}}</button>
                    <button type="button" id="signButton" :disabled="loading" @click="deny()"
                        class="btn btn-danger float-right"><i class="fa fa-thumbs-down"></i>
                        Recusar <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {       
        data() {
            return {
                tokenTipo: 'E',
                loading: false,
                file: {},
                request: {
                    motivo: '',
                }
            }
        },
        methods: {
            deny() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) {
                        return;
                    }
                    this.request.id = this.file.id;
                    this.loading = true;
                    this.$store.dispatch('denyFile', this.request).then(response => {
                        toastr({
                            title: response.message,
                            icon: response.status
                        });
                        $('#ModalRecusa').modal('toggle');
                        this.$store.commit('REFRESH_USER_FILES', Math.random().toString(36).substr(2, 5));
                        this.$store.dispatch('getUserData');
                    }).catch(error => {
                        toastr({
                            title: error.message,
                            icon: error.status
                        });
                    }).finally(() => {
                        this.loading = false;
                    });
                });
            }
        }
    }
</script>